import { Component } from '@angular/core';
import { EntityError } from '@cime/breeze-client';
import { EntitiesErrors } from '@common/classes/entities-errors';

@Component({
    selector: 'app-entities-errors',
    templateUrl: './entities-errors.component.html',
    styleUrls: ['./entities-errors.component.scss']
})
export class EntitiesErrorsComponent {
    errors: EntityError[];

    constructor(errors: EntitiesErrors) {
        this.errors = errors.errors;
    }
}
